<div [style.width]="tableWidth" [id]="tableOptions.id">
  <div class="options">

    <div *ngIf="tableOptions.showTableHeader" class="table-header">
      <h2>{{tableOptions.tableHeader}}</h2>
    </div>


    <div class="flex-end table-filters">
      <!-- search -->
      <div *ngIf="tableOptions.showSearch" class="search flex">
        <app-text-input [(ngModel)]="searchFilter" [placeholder]="tableOptions.searchPlaceholder"
          (ngModelChange)="filterDataset()"></app-text-input>
        <ion-icon class="help-icon" (click)="searchHelp()" name="help-circle-outline"></ion-icon>
      </div>

      <!-- filters -->
      <div *ngFor="let filter of tableOptions.filters" class="filter">
        <ion-select (ionChange)="filterDataset(filter)" [(ngModel)]="filtersSelected[filter.field]" interface="popover">
          <ion-select-option *ngIf="filter.unselectedLabel != null"
            value="">{{filter.unselectedLabel}}</ion-select-option>
          <ion-select-option *ngFor="let item of filter.values; let i = index" [value]="item">
            {{ filter.labels && filter.labels[i] != null ? filter.labels[i] : filter.values[i] }}
          </ion-select-option>
        </ion-select>
      </div>

      <!-- custom filter template -->
      <div *ngIf="customFilterTemplate != null" class="filter">
        <ng-container *ngTemplateOutlet="customFilterTemplate; context: { }"></ng-container>
      </div>

    </div>


    <!-- media -->
    <input style="display: none;" #fileInput type="file" [accept]="tableOptions.mediaOptions"
      (change)="uploadMedia($event)">

    <!-- Import button -->
    <ion-button *ngIf="tableOptions.showImportButton" [disabled]="busy" [class.margin-top]="tableOptions.showSearch"
      class="header-button" color="primary" (click)="fileInput.click()">
      Import {{tableOptions.type}}
    </ion-button>

    <div class="row-buttons flex-end">

      <div *ngIf="tableOptions.enableMultiSelect === true">
        <ion-button color="danger" [disabled]="!hasSelectedItems()"
          (click)="emitMultiSelectAction('delete')">Delete</ion-button>
      </div>

      <ion-button *ngIf="tableOptions.showReorder" [class.margin-top]="tableOptions.showSearch" color="secondary"
        class="header-button" (click)="reorder = !reorder">{{reorder ? 'Done' : 'Sort'}}</ion-button>

      <!-- add item button -->
      <ion-button *ngIf="tableOptions.addType === 2" [disabled]="busy" [class.margin-top]="tableOptions.showSearch"
        color="primary" class="header-button" (click)="addBtnClicked()">
        Add {{tableOptions.addBtnLabel ? tableOptions.addBtnLabel : tableOptions.type}}
      </ion-button>

      <!-- custom buttons -->
      <ng-container *ngFor="let btn of tableOptions.customButtons">
        <ion-button [ngClass]="btn.cssClass" [disabled]="btn.disabled" [class.margin-top]="tableOptions.showSearch"
          [title]="btn.tooltip" [fill]="btn.fill"
          [color]="btn.color ?? 'primary'" class="header-button r" (click)="btn.onClick()">{{btn.label}} </ion-button>
        <ion-icon *ngIf="btn.showHelpIcon" class="help-icon" (click)="btn.onHelpClick()"
          name="help-circle-outline"></ion-icon>
      </ng-container>

    </div>
  </div>

  <!-- table -->
  <div [class]="tableOptions.tableCssClass ?? 'data-table'">

    <table *ngIf="reorder === false">

      <!-- header row -->
      <tr class="header-row">
        <th *ngIf="tableOptions.enableMultiSelect === true">
          <ion-checkbox color="primary" slot="start" [(ngModel)]="selectedAll"
            (ngModelChange)="toggleSelectAll()"></ion-checkbox>
        </th>
        <th *ngFor="let item of tableOptions.headers; let i = index" [class.sortable]="item.sortable" tappable
          (click)="sort(item)" [ngClass]="{'ion-text-right': item.isNumber }"
          [style.min-width]="item.minWidth ? item.minWidth : null"
          [title]="item.isLocked != null ? 'This field cannot be edited once sales starts' : ''">
          {{item.label}}
          <ion-icon *ngIf="item.sortable && sortBy === item.field"
            [name]="sortAsc ? 'chevron-down-outline' : 'chevron-up-outline'"></ion-icon>
          <ion-icon *ngIf="sortBy !== item.field && item.sortable" name="swap-vertical-outline"
            color="medium"></ion-icon>
          <ion-icon slot="start" *ngIf="item.isLocked != null" class="no-pointer-evts"
            [name]="(item.isLocked === true) ? 'lock-closed-outline' : 'lock-open-outline'"></ion-icon>
        </th>
        <th *ngIf="tableOptions.includeRowButton === true" class="no-border">{{ tableOptions.rowButtonHeader }}</th>
        <th
          *ngIf="tableOptions.allowEdit || tableOptions.allowDelete || tableOptions.addType === 1 || tableOptions.customActions.length > 0"
          class="no-border">
        </th>
      </tr>

      <!-- data rows -->
      <tr *ngFor="let item of 
                  (tableOptions.includePagination === true 
                    ? (filteredDataSet | paginate: { itemsPerPage: tableOptions.paginationItemsPerPage, currentPage: tableOptions.paginationCurrentPage, totalItems
                    : tableOptions.paginationTotalItems }) : filteredDataSet) ; let itemIndex = index"
        (click)="selectByPk(item)" tappable
        [class.disabled]="tableOptions.propertyForDisabled != null && item[tableOptions.propertyForDisabled]===true"
        [style.border-left]="item?.color ? '20px solid ' + item.color : 'none'"
        [style.background]="item[tableOptions.bgProp]" [class.even]="itemIndex % 2 === 0" class="data-row">

        <!-- first column checkbox -->
        <td *ngIf="tableOptions.enableMultiSelect && tableOptions.primaryKey != null">
          <ion-checkbox color="primary" slot="start" [ngModel]="selectedItems[item[tableOptions.primaryKey]]"
            (ngModelChange)="toggleItemSelected(item)">
          </ion-checkbox>
        </td>

        <!-- now add all columns defined in tableOptions.columns -->
        <ng-container *ngFor="let col of tableOptions.columns; let i = index">

          <!-- standard single cell columns -->
          <td [style.max-width]="col.maxWidth" [style.min-width]="col.minWidth" *ngIf="col.type !== 'text-array'"
            [style.text-wrap]="col.nowrap ? 'nowrap' : 'pretty'"
            [style.word-break]="col.nowrap ? 'normal' : 'break-word'" [ngClass]="{
              'ion-text-left': col.type === 'checkbox' || col.type === 'content',
              'ion-text-right': col.type === 'number' || col.type === 'currency' || col.type === 'percent',
              'ion-text-center': col.type === 'boolean'
            }" [class.shrink]="col.shrinkCell" [class]="col.customColor == null ? '' : (item[col.customColor] ?? '')">
            <span *ngIf="(i === 0 && tableOptions.indicateNewItems === true)"
              [class.notify]="item[tableOptions.newItemLookUp]">&nbsp;</span>

            <!-- if clickable columns enabled and this column, display value as link with click handler -->
            <span
              *ngIf="(i === tableOptions.clickableColumn && tableOptions.enableClickableColumn === true && col.type !== 'checkbox')"
              (click)="columnClick(item)" class="link">
              {{item[col.classProperty]}}
            </span>

            <span *ngIf="col.linkCallback != null" (click)="col.linkCallback(item)" class="link">
              {{item[col.classProperty]}}
            </span>

            <span *ngIf="tableOptions.enableClickableColumnForCheckCol === true && i === tableOptions.clickableColumn"
              (click)="columnClick2(item.value)"
              [class]="tableOptions.propertyForDisabled != null && item[tableOptions.propertyForDisabled] === true ? 'disabled-link' : 'link'">
              {{item[col.classProperty]}}
            </span>

            <!-- if clickable columns disabled, or not this column, just display the value -->
            <ng-container
              *ngIf="!editItemDic[itemIndex] && col.copyIconOnly !== true && tableOptions.clickableColumn !== i && col.linkCallback == null">
              <span
                *ngIf="(i !== tableOptions.clickableColumn || tableOptions.enableClickableColumn === false) && 
                col.type != null && 
                ![ 'content', 'checkbox', 'number', 'currency', 'select', 'url', 'tel', 'button', 'button-array', 'date', 'boolean'].includes(col.type)">
                {{(item[col.classProperty] === true) ? 'Y' : (item[col.classProperty] === false) ? 'N' :
                item[col.classProperty]}}
              </span>
              <!-- <span
                *ngIf="!['checkbox', 'number', 'currency', 'percent', 'select', 'url', 'button', 'date'].includes(col.type)">
                {{ item[col.classProperty] }}
              </span> -->
              <!-- this is a checkbox column -->
              <span *ngIf="col.type === 'checkbox'">
                <app-checkbox-input [disabled]="true" [(ngModel)]="item[col.classProperty]"></app-checkbox-input>
              </span>
              <span *ngIf="col.type === 'content'">
                <img *ngIf="item[col.classProperty].path" [src]="item[col.classProperty].path"
                  [height]="tableOptions.contentUploadConfig?.previewHeight" alt="image">
                <p *ngIf="!item[col.classProperty].path">No Image</p>
              </span>
              <span *ngIf="col.type === 'date'">
                {{ item[col.classProperty] == null ? '-' : item[col.classProperty] | luxon: col.dateFormat }}
              </span>
              <span *ngIf="col.type === 'number'">
                {{ item[col.classProperty] == null ? '-' : item[col.classProperty] | number }}
              </span>
              <span *ngIf="col.type === 'tel'">
                {{ item[col.classProperty] == null ? '-' : item[col.classProperty] | phone }}
              </span>
              <span *ngIf="col.type === 'currency'">
                {{ item[col.classProperty] == null ? '-' : item[col.classProperty] | currency: (col.currencyCol ?
                item[col.currencyCol] : col.currency) : 'symbol-narrow' : (col.currencyFormat ?? '1.0-0') }}
              </span>
              <span *ngIf="col.type === 'select'">
                {{ getOptionDisplayValue(col.classProperty, item[col.classProperty]) }}
              </span>
              <span *ngIf="col.type === 'url'">
                <a *ngIf="col.url != null" (click)="openUrl(item[col.url])">{{ item[col.classProperty] }}</a>
                <a *ngIf="col.url == null" (click)="openUrl(item[col.classProperty])">{{ item[col.classProperty] }}</a>
              </span>
              <span *ngIf="col.type === 'button'">
                <ion-button [color]="(col.customColor != null) ? (item[col.customColor] ?? 'secondary') : 'secondary'"
                  size="small" (click)="col.callback(item)">
                  {{col.displayValue != null ? item[col.displayValue] : ''}}</ion-button>
              </span>
              <span *ngIf="col.type === 'button-array'">
                <ion-button *ngFor="let button of col.buttons" size="small"
                  [color]="(col.customColor != null) ? (item[col.customColor] ?? 'secondary') : 'secondary'"
                  (click)="button.onClick(item)">
                  {{button.label}}</ion-button>
              </span>
            </ng-container>
            <ng-container *ngIf="col.showWarningIcon === true && item['showWarningIcon'] === true">
              <ion-icon color="warning" name="warning-outline"></ion-icon>
            </ng-container>

            <!-- Editable input -->
            <ng-container *ngIf="editItemDic[itemIndex]">
              <span *ngIf="(i !== tableOptions.clickableColumn || tableOptions.enableClickableColumn === false)">
                <ng-container *ngIf="!col.enableInlineEdit">
                  <span
                    *ngIf="col.type != null && !['checkbox', 'number', 'currency', 'select', 'url', 'button'].includes(col.type)">
                    {{ item[col.classProperty] }}
                  </span>
                  <span *ngIf="col.type === 'number'">
                    {{ item[col.classProperty] | number }}
                  </span>
                  <span *ngIf="col.type === 'url'">
                    <a [href]="item[col.classProperty]" target="_blank">{{ item[col.classProperty] }}</a>
                  </span>
                  <span *ngIf="col.type === 'button'">
                    <ion-button
                      [color]="(col.customColor != null) ? (item[col.customColor] ?? 'secondary') : 'secondary'"
                      size="small" (click)="col.callback(item)">{{col.displayValue != null ? item[col.displayValue] :
                      ''}}
                    </ion-button>
                  </span>
                  <span *ngIf="col.type === 'currency'">
                    {{ item[col.classProperty] | currency: col.currency : 'symbol-narrow' : (col.currencyFormat ??
                    '1.0-0') }}
                  </span>
                  <span *ngIf="col.type === 'select'">
                    {{ getOptionDisplayValue(col.classProperty, item[col.classProperty]) }}
                  </span>
                  <span *ngIf="col.type === 'checkbox'">
                    <app-checkbox-input [disabled]="true" [(ngModel)]="item[col.classProperty]"></app-checkbox-input>
                  </span>
                </ng-container>
                <ng-container *ngIf="col.enableInlineEdit" [ngSwitch]="col.type">
                  <ng-container *ngSwitchCase="'date'">
                    <span *ngIf="col.displayValue">
                      <span>{{item[col.displayValue | luxon]}}</span>
                      <span class="dateinput-toggle" (click)="pickDate(itemIndex)">
                        <input type="date" #dateInput class="date-input" [value]="item[col.displayValue]"
                          (change)="onBlur(item[tableOptions.primaryKey ?? ''], $event)">
                        <ion-icon name="calendar-outline"></ion-icon>
                      </span>
                    </span>
                    <app-datetime-input *ngIf="col.displayValue == null" [type]="'date'"
                      [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                      errorDisplay="inline">
                    </app-datetime-input>
                  </ng-container>
                  <app-email-input *ngSwitchCase="'email'" [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                    errorDisplay="inline">
                  </app-email-input>
                  <app-number-input *ngSwitchCase="'number'" [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [allowZero]="true"
                    [required]="col.isRequired" errorDisplay="inline">
                  </app-number-input>
                  <app-datetime-input *ngSwitchCase="'time'" [placeholder]="tableOptions.headers[i].label"
                    [type]="'time'" [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                    errorDisplay="inline">
                  </app-datetime-input>
                  <app-checkbox-input *ngSwitchCase="'checkbox'" [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                    errorDisplay="inline">
                  </app-checkbox-input>
                  <app-select-input *ngSwitchCase="'select'" [placeholder]="'Select ' + tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [options]="col.options"
                    [required]="col.isRequired" errorDisplay="inline"
                    (onValueSelected)="col.callback(editItemDic[itemIndex], $event)"></app-select-input>
                  <app-number-input *ngSwitchCase="'currency'" [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [maxlength]="col.maxLength"
                    [currency]="col.currency" [allowZero]="true" [required]="col.isRequired"
                    errorDisplay="inline"></app-number-input>
                  <app-phone-input *ngSwitchCase="'tel'" [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [required]="col.isRequired"
                    errorDisplay="inline">
                  </app-phone-input>
                  <app-content-upload *ngSwitchCase="'content'" uploadTitle="" [showUploadButtonText]="false"
                    (fileSelected)="selectedFile($event, itemIndex)" (fileRemoved)="clearImage(itemIndex)"
                    [files]="editItemDic[itemIndex][col.classProperty]" [config]="tableOptions.contentUploadConfig">
                  </app-content-upload>
                  <app-text-input *ngSwitchDefault [placeholder]="tableOptions.headers[i].label"
                    [(ngModel)]="editItemDic[itemIndex][col.classProperty]" [type]="col.type"
                    [maxLength]="col.maxLength" [required]="col.isRequired" errorDisplay="inline"></app-text-input>
                </ng-container>
              </span>
            </ng-container>

            <ion-icon *ngIf="col.copyOption"
              (click)="copyToClipboard(item[col.classProperty], tableOptions.headers[i].label)"
              name="copy-outline"></ion-icon>
          </td>

          <!-- text array column -->
          <ng-container *ngIf="col.type === 'text-array'">
            <td *ngFor="let array of item[col.classProperty]">
              <span>{{array[col.arrayProperty]}}</span>
            </td>
          </ng-container>

        </ng-container>

        <!-- Action buttons (edit, delete, etc.) -->
        <td class="no-border ion-text-center edit-opts"
          *ngIf="tableOptions.allowEdit || tableOptions.allowDelete || tableOptions.customActions.length > 0">
          <ion-buttons>
            <ng-container *ngIf="!editItemDic[itemIndex]">
              <ion-button [disabled]="busy" *ngIf="tableOptions.allowEdit" fill="clear" color="primary"
                (click)="toggleEdit(itemIndex)">
                <ion-icon slot="icon-only" name="create-outline"></ion-icon>
              </ion-button>
              <ion-button [disabled]="busy" *ngIf="tableOptions.allowDelete" fill="clear" color="danger"
                (click)="archiveItem(itemIndex)">
                <ion-icon slot="icon-only" name="trash-outline"></ion-icon>
              </ion-button>
              <ion-button *ngFor="let btn of tableOptions.customActions" [ngClass]="btn.cssClass"
                [disabled]="btn.disabled" [class.margin-top]="tableOptions.showSearch" [color]="btn.color ?? 'primary'"
                [fill]="btn.label ? (btn.fill ?? 'solid') : 'clear'" [title]="btn.tooltip" (click)="btn.onClick(item)">
                <ion-icon *ngIf="btn.icon" [slot]="btn.label ? 'start' : 'icon-only'" [name]="btn.icon"></ion-icon>
                <span *ngIf="btn.label">{{btn.label}}</span>
              </ion-button>
            </ng-container>
            <ng-container *ngIf="editItemDic[itemIndex]">
              <ion-button [disabled]="busy" fill="clear" color="danger" (click)="toggleEdit(itemIndex)">
                <ion-icon slot="icon-only" name="close-outline"></ion-icon>
              </ion-button>
              <ion-button [disabled]="busy" fill="clear" color="success" (click)="editItem(itemIndex)">
                <ion-icon slot="icon-only" name="checkmark-outline"></ion-icon>
              </ion-button>
            </ng-container>
          </ion-buttons>
        </td>

        <td class="no-border"
          *ngIf="tableOptions.allowEdit === false && tableOptions.allowDelete === false && tableOptions.addType === 1 && tableOptions.customActions.length === 0">
        </td>

        <!-- finish off with a column holding an action button -->
        <td *ngIf="tableOptions.includeRowButton" class="no-border ion-text-right">
          <!--disabled and greyed out if the order has been delivered-->
          <ion-button id="row-btn" size="small" color="secondary" (click)="rowButtonClick($event, item)">
            {{tableOptions.rowButtonText}}</ion-button>
        </td>

        <!-- and or with a custom last column template-->
        <td *ngIf="tableOptions.includeLastColTemplate" class="no-border ion-text-right">
          <div>
            <ng-container *ngTemplateOutlet="customLastColTemplate; context: { item: item}"></ng-container>
          </div>
        </td>

      </tr>

      <!-- a totals row if specified -->
      <tr *ngIf="tableOptions.showTotalRow === true && tableOptions.dataSet.length > 0" class="total-row">
        <td *ngFor="let col of tableOptions.columns" class="ion-text-right">
          {{ col.type === 'currency' ? (getColumnTotal(col.classProperty) | currency: col.currency : 'symbol-narrow' :
          (col.currencyFormat ?? '1.0-0')):
          (getColumnTotal(col.classProperty) | number )}}
        </td>
        <td *ngIf="tableOptions.includeRowButton"></td>
        <td
          *ngIf="tableOptions.allowEdit || tableOptions.allowDelete || tableOptions.addType === 1 || tableOptions.customActions.length > 0">
        </td>
      </tr>

      <!-- message to show if dataset is empty-->
      <tr *ngIf="tableOptions.dataSet.length === 0 || filteredDataSet.length === 0" class="ion-text-center">
        <td [attr.colspan]="tableOptions.columns.length">{{tableOptions.noItemsMessage}}</td>
        <td *ngIf="tableOptions.includeRowButton"></td>
        <td
          *ngIf="tableOptions.allowEdit || tableOptions.allowDelete || tableOptions.addType === 1 || tableOptions.customActions.length > 0">
        </td>
      </tr>

      <!-- Row added to the bottom of table if add type is INLINE -->
      <tr *ngIf="tableOptions.addType === 1" class="edit-row">

        <td *ngIf="tableOptions.enableMultiSelect && tableOptions.primaryKey != null"></td>

        <td *ngFor="let col of tableOptions.columns; let colIndex = index;"
          [ngClass]="{'ion-text-center': col.type === 'checkbox', 'ion-text-right': col.type === 'number' || col.type === 'currency' , 'form-inputs': true}"
          [class.shrink]="col.shrinkCell">

          <ng-container *ngIf="col.canEdit" [ngSwitch]="col.type">
            <ng-container *ngSwitchCase="'date'">
              <span *ngIf="col.displayValue">
                <span>{{todayDateFormat}}</span>
                <span class="dateinput-toggle" (click)="newDate?.nativeElement.showPicker()">
                  <input title="Date" type="date" #newDateInput class="date-input" [value]="newItem[col.classProperty]"
                    (change)="updateDateFormat($event, col.classProperty)">
                  <ion-icon name="calendar-outline"></ion-icon>
                </span>
              </span>
              <app-datetime-input *ngIf="col.displayValue == null" [type]="'date'"
                [(ngModel)]="newItem[col.classProperty]" errorDisplay="inline"
                (checkingValidity)="onInputValidationChange($event, $event.isValid)"
                (changed)="onInputChange()"></app-datetime-input>
            </ng-container>
            <app-email-input *ngSwitchCase="'email'" [(ngModel)]="newItem[col.classProperty]"
              [placeholder]="tableOptions.headers[colIndex].label" [maxLength]="col.maxLength"
              [required]="col.isRequired" errorDisplay="inline"
              (checkingValidity)="onInputValidationChange($event, $event.isValid)"
              (changed)="onInputChange()"></app-email-input>
            <app-number-input *ngSwitchCase="'number'" [maxLength]="col.maxLength"
              [(ngModel)]="newItem[col.classProperty]" [placeholder]="tableOptions.headers[colIndex].label"
              [required]="col.isRequired" errorDisplay="inline" [allowZero]="true"
              (checkingValidity)="onInputValidationChange($event, $event.isValid)" (changed)="onInputChange()">
            </app-number-input>
            <app-datetime-input *ngSwitchCase="'time'" [type]="'time'" [(ngModel)]="newItem[col.classProperty]"
              [required]="col.isRequired" errorDisplay="inline"
              (checkingValidity)="onInputValidationChange($event, $event.isValid)"
              (changed)="onInputChange()"></app-datetime-input>
            <app-checkbox-input *ngSwitchCase="'checkbox'" [(ngModel)]="newItem[col.classProperty]"
              [required]="col.isRequired" errorDisplay="inline"
              (checkingValidity)="onInputValidationChange($event, $event.isValid)"
              (changed)="onInputChange()"></app-checkbox-input>
            <app-select-input *ngSwitchCase="'select'" [placeholder]="'Select ' + tableOptions.headers[colIndex].label"
              [(ngModel)]="newItem[col.classProperty]" [options]="col.options" [required]="col.isRequired"
              errorDisplay="inline" (onValueSelected)="col.callback(newItem, $event)"
              (checkingValidity)="onInputValidationChange($event, $event.isValid)" (changed)="onInputChange()">
            </app-select-input>
            <app-number-input *ngSwitchCase="'currency'" [placeholder]="tableOptions.headers[colIndex].label"
              [(ngModel)]="newItem[col.classProperty]" [maxLength]="col.maxLength" [required]="col.isRequired"
              errorDisplay="inline" [currency]="col.currency" [allowZero]="true"
              (checkingValidity)="onInputValidationChange($event, $event.isValid)"
              (changed)="onInputChange()"></app-number-input>
            <app-phone-input *ngSwitchCase="'tel'" [placeholder]="tableOptions.headers[colIndex].label"
              [(ngModel)]="newItem[col.classProperty]" [required]="col.isRequired" errorDisplay="inline"
              (checkingValidity)="onInputValidationChange($event, $event.isValid)" (changed)="onInputChange()">
            </app-phone-input>
            <app-content-upload *ngSwitchCase="'content'" uploadTitle="" [showUploadButtonText]="false"
              (fileSelected)="selectedFile($event); onInputChange()" (fileRemoved)="clearImage(); onInputChange()"
              [files]="newItem[col.classProperty]" [config]="tableOptions.contentUploadConfig">
            </app-content-upload>
            <app-text-input *ngSwitchDefault [placeholder]="tableOptions.headers[colIndex].label"
              [(ngModel)]="newItem[col.classProperty]" [type]="col.type" [maxLength]="col.maxLength"
              [required]="col.isRequired" errorDisplay="inline"
              (checkingValidity)="onInputValidationChange($event, $event.isValid)"
              (changed)="onInputChange()"></app-text-input>
          </ng-container>
        </td>
        <td class="ion-text-center">
          <ion-button [disabled]="busy || !isAddFormValid" fill="solid" color="success"
            (click)="addItem()">Add</ion-button>
        </td>
        <td *ngIf="tableOptions.includeRowButton"></td>
      </tr>

    </table>

    <pagination-controls *ngIf="tableOptions.includePagination"
      (pageChange)="tableOptions.paginationCurrentPage = $event"></pagination-controls>


    <!-- Will replace the current table when the user toggles the table re-order -->
    <ion-reorder-group *ngIf="reorder === true" (ionItemReorder)="reorderItems($event)" disabled="false">
      <ion-item *ngFor="let item of tableOptions.dataSet">
        <div *ngFor="let col of tableOptions.columns; let i = index">
          <span *ngIf="col.type !== 'content' && col.showInSort === true">
            {{item[col.classProperty]}}&nbsp;
          </span>
        </div>
        <ion-reorder slot="end"></ion-reorder>
      </ion-item>
    </ion-reorder-group>

  </div>
</div>